import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machine-tasks-report-table', () => {
  import('./internal/machine-tasks-report-table').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.machine-task-show-page', () => {
  import('./internal/machine-task-show-page').then(({ default: Component }) => Component());
});
